import { render, staticRenderFns } from "./window-box.vue?vue&type=template&id=03c73926&scoped=true&"
var script = {}
import style0 from "./window-box.vue?vue&type=style&index=0&id=03c73926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c73926",
  null
  
)

export default component.exports